import { AnyAction } from 'redux';
import { CancelTokenSource } from 'axios';
import { setRequestStatus } from 'data-layer-cr/dist/network';
import { ServerResponse } from 'data-layer-cr/dist/models';

// Network
import processRequest from '../../../services/processRequest';

// Redux
import { AppThunk, AsyncAppThunk, AsyncDispatch } from '../../ThunkTypes';

// Actions
import {
  updateInspectionReport,
  updateVehicleRegister,
} from '../slice/quotationSlice';
import {
  DOWNLOAD_INSPECTION_REPORT,
  DOWNLOAD_VEHICLE_REGISTRY,
} from '../requestIdentifiers';

export const resetFiles =
  (): AppThunk =>
  (dispatch): void => {
    dispatch(updateInspectionReport(''));
    dispatch(updateVehicleRegister(''));
  };

/**
 * Request the inspection report base64 file
 *
 * @param urlSalt - url salt identifying the quotation
 * @param fileName - The file name to look for
 * @param cancelTokenSource - axios cancel token ref, allows the ui to cancel the request without dispatching
 * another action
 */
export const updateInspectionReportValue =
  (
    urlSalt: string,
    fileName: string,
    cancelTokenSource: CancelTokenSource,
  ): AsyncAppThunk =>
  async (dispatch: AsyncDispatch): Promise<AnyAction> => {
    dispatch(setRequestStatus(DOWNLOAD_INSPECTION_REPORT, 'requesting'));
    try {
      const { data } = await processRequest<ServerResponse<string>>({
        method: 'GET',
        url: `inspections/${urlSalt}/file/${fileName}`,
        cancelTokenSource,
      });
      dispatch(updateInspectionReport(data));
      return dispatch(setRequestStatus(DOWNLOAD_INSPECTION_REPORT, 'success'));
    } catch (e) {
      return dispatch(setRequestStatus(DOWNLOAD_INSPECTION_REPORT, 'failure'));
    }
  };

/**
 * Request the vehicle registry base64 file
 *
 * @param urlSalt - url salt identifying the quotation
 * @param fileName - The file name to look for
 * @param cancelTokenSource - axios cancel token ref, allows the ui to cancel the request without dispatching
 * another action
 */
export const updateVehicleRegisterValue =
  (
    urlSalt: string,
    fileName: string,
    cancelTokenSource: CancelTokenSource,
  ): AsyncAppThunk =>
  async (dispatch: AsyncDispatch): Promise<AnyAction> => {
    dispatch(setRequestStatus(DOWNLOAD_VEHICLE_REGISTRY, 'requesting'));
    try {
      const data = await processRequest<string>({
        method: 'GET',
        url: `BlobStorage/download/${urlSalt}/${fileName}`,
        cancelTokenSource,
      });
      dispatch(updateVehicleRegister(data));
      return dispatch(setRequestStatus(DOWNLOAD_VEHICLE_REGISTRY, 'success'));
    } catch (e) {
      return dispatch(setRequestStatus(DOWNLOAD_VEHICLE_REGISTRY, 'failure'));
    }
  };
